export default "__VITE_ASSET__BP3v6noI__"